import {
  IsNotEmpty,
  Validate,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";
import { Match } from "./decorators/match";

@ValidatorConstraint({ name: "PasswordComplexity", async: false })
export class PasswordComplexity implements ValidatorConstraintInterface {
  validate(password: string) {
    return (
      typeof password === "string" &&
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    );
  }

  defaultMessage(args: ValidationArguments) {
    const password = args.value;
    const messages: string[] = [];

    if (password.length < 8) {
      messages.push("minLength");
    }
    if (!/[A-Z]/.test(password)) {
      messages.push("atLeastOneUppercaseLetter");
    }
    if (!/[a-z]/.test(password)) {
      messages.push("atLeastOneLowercaseLetter");
    }
    if (!/[0-9]/.test(password)) {
      messages.push("atLeastOneNumber");
    }
    if (!/[^A-Za-z0-9]/.test(password)) {
      messages.push("atLeastOneSpecialCharacter");
    }

    return messages.join(", ");
  }
}

export class SetNewPasswordInput {
  // Default Cognito password policy
  @Validate(PasswordComplexity)
  public password: string;

  @IsNotEmpty({ message: "Confirm Password is required" })
  @Match("password", {
    message: "Passwords do not match",
  })
  public confirmPassword: string;
}
